// extracted by mini-css-extract-plugin
module.exports = {"hidden":"plot_hidden__lotQF","visible":"plot_visible__2J5dh","block":"plot_block__2ENqI","badge":"plot_badge__1oUsh"};